import CreateInvestmentError from './CreateInvestmentError';
class InvalidBricksQuantity extends CreateInvestmentError {
    constructor(options) {
        super('Invalid brick purchase quantity', options);
    }
}
export default InvalidBricksQuantity;
